export default function packageListReducer( state = {}, action )
{
    switch( action.type )
    {
        case 'PACKAGE_LIST_SUCCEEDED':
            return action.list;

        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/lib/reducers/package-list.js